export { default } from './ProductPrice';